import request from '@/utils/request'
// 报表任务列表
export function getList(params) {
  return request({
    url: '/report_form/export_task',
    method: 'get',
    params
  })
}

// 报表任务列表
export function reportSelect(params) {
  return request({
    url: '/report_form/export_task/select_condition',
    method: 'get',
    params
  })
}
